import React, { useMemo } from 'react'
import PriceRowPointsSpend from '../PriceRowPointsSpend'
import Group from 'components/utils/Group'
import PriceRowPrice from '../PriceRowPrice'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import PriceRowSale from '../PriceRowSale'
import PriceRowPointsSale from '../PriceRowPointsSale'
import { generateLoyaltyPointsCalculatorMerchandiseOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'

const OrText = styled(BodyText)`
  line-height: ${rem(20)};
`

interface Props {
  variant: App.MerchandiseOfferVariant
  quantity: number
  direction: 'horizontal' | 'stack'
  size: 'S' | 'L'
  displayEarnPoints?: boolean
}

function PriceRowMerchandisePriceStack(props: Props) {
  const {
    variant,
    quantity,
    size,
    direction,
    displayEarnPoints,
  } = props

  const isOnSale = variant.price !== variant.regularPrice
  const isOnPointsSale = variant.pointsPrice !== variant.pointsRegularPrice

  const price = variant.price * quantity
  const points = variant.pointsPrice * quantity
  const regularPrice = variant.regularPrice * quantity
  const pointsRegularPrice = variant.pointsRegularPrice * quantity

  // Generate loyalty points calculation request for the current price
  const loyaltyPointsCalculationRequest = useMemo(() => {
    return generateLoyaltyPointsCalculatorMerchandiseOptions(variant, {
      price,
    })
  }, [variant, price])

  return <Group
    direction={direction === 'horizontal' ? 'horizontal' : 'vertical'}
    gap={direction === 'horizontal' ? 8 : (size === 'S' ? 4 : 8)}
    tabletGap={8}
    verticalAlign={direction === 'horizontal' ? 'start' : undefined}
  >
    <Group direction="horizontal" gap={8} verticalAlign="start">
      <div>
        {!!points && <PriceRowPointsSpend points={points} size={size} />}
        {isOnPointsSale && <PriceRowPointsSale value={pointsRegularPrice} colour="neutral-three" />}
      </div>
    </Group>
    {!!price && !!points && <OrText variant="small" colour="neutral-three">or</OrText>}
    <div>
      {!!price && <PriceRowPrice data-testid="merch-pdp-price-amount" price={price} size={size} saleUnit="" priceFormat="dynamicDollar" />}
      {isOnSale && <PriceRowSale value={regularPrice} colour="neutral-three" priceFormat="dynamicDollar" />}
      {displayEarnPoints && (
        <LoyaltyPointsEarn
          calculationType="ratio"
          calculationRequests={loyaltyPointsCalculationRequest}
          hideInfoIcon
        />
      )}
    </div>
  </Group>
}

export default PriceRowMerchandisePriceStack
